// Fichas de cliente abiertas — la barra de pestañas.
//
// Lissette, 2026-08-21, de una reunion del equipo: "si entra a un cliente y se
// va a buscar otra cosa, que el tag del cliente se quede abierto alli para no
// tener que buscarlo de nuevo... y que el tab tenga una x para cerrarlo".
//
// Igual que las pestañas del navegador: abres una ficha, te vas a Polizas o a
// Tareas, y el cliente sigue ahi arriba a un clic.
//
// DOS DECISIONES QUE NO SE PUEDEN CAMBIAR SIN PENSARLO:
//
// 1. Esto NO se guarda en el disco del navegador. La correccion de auditoria
//    C2 (2026-05-20) saco de localStorage todos los datos de clientes porque
//    quedaban en texto plano en la maquina: cualquier XSS, extension del
//    navegador o portatil dado de baja se llevaba el hogar entero. Un nombre
//    de cliente de una agencia de seguros de salud es exactamente ese dato.
//    Las pestañas viven en memoria: aguantan moverse entre modulos, que es lo
//    que ella pidio, y se van al recargar la pagina.
//
// 2. Hay un tope. Sin el, un dia de trabajo son sesenta pestañas y la barra se
//    come la pantalla — justo lo contrario de ahorrar tiempo.

export const MAX_FICHAS = 8;

// El nombre que se ve en la pestaña. Nunca vacio: una pestaña sin texto no se
// puede ni leer ni pulsar con confianza.
export function nombreDeFicha(cl) {
  if (!cl) return '';
  const n = [cl.firstName, cl.lastName].filter(Boolean).join(' ').trim();
  return n || String(cl.name || '').trim() || String(cl.id || '').slice(0, 8);
}

// Abre (o trae al frente) la ficha de un cliente.
//
// Volver a entrar a un cliente que ya tiene pestaña NO crea otra ni la mueve
// de sitio: si las pestañas se reordenaran solas, la que estabas mirando
// cambiaria de posicion cada vez y habria que buscarla con la vista.
export function abrirFicha(fichas, cl, activaId) {
  const lista = Array.isArray(fichas) ? fichas : [];
  if (!cl || !cl.id) return lista;
  const nombre = nombreDeFicha(cl);
  const ya = lista.find((f) => f.id === cl.id);
  if (ya) {
    // Solo se refresca el nombre (lo pudieron corregir en la ficha).
    return ya.nombre === nombre ? lista : lista.map((f) => (f.id === cl.id ? { ...f, nombre } : f));
  }
  return recortar([...lista, { id: cl.id, nombre }], activaId);
}

// Al pasar del tope se suelta la MAS VIEJA, pero nunca la que esta abierta
// ahora mismo: cerrarle a alguien la pestaña que esta mirando es el peor
// momento posible para soltar una.
export function recortar(fichas, activaId) {
  const lista = Array.isArray(fichas) ? fichas : [];
  if (lista.length <= MAX_FICHAS) return lista;
  let sobra = lista.findIndex((f) => f.id !== activaId);
  if (sobra === -1) sobra = 0;
  return lista.filter((_, i) => i !== sobra);
}

export function cerrarFicha(fichas, id) {
  return (Array.isArray(fichas) ? fichas : []).filter((f) => f.id !== id);
}
